import { Skeleton } from '@material-ui/lab';
import React from 'react';
import styled from 'styled-components';

interface OptionListSkeletonProps {
  type: 'default' | 'advanced';
}

function OptionListSkeleton({ type }: OptionListSkeletonProps) {
  return (
    <StyledOptionListSkeleton type={type}>
      {type === 'default' ? (
        <>
          {Array.from({ length: 2 }, (_, index) => (
            <StyledSkeleton animation="wave" variant="rect" height={32} key={index} />
          ))}
          <StyledSkeleton animation="wave" variant="rect" height={300} />
          <StyledSkeleton animation="wave" variant="rect" height={32} />
        </>
      ) : (
        <>
          {Array.from({ length: 10 }, (_, index) => (
            <StyledSkeleton animation="wave" variant="rect" height={53} key={index} />
          ))}
        </>
      )}
    </StyledOptionListSkeleton>
  );
}

const StyledOptionListSkeleton = styled.div<{ type: 'default' | 'advanced' }>`
  padding: 22px 0;
  display: flex;
  flex-direction: column;
  row-gap: ${({ type }) => (type === 'default' ? `22px` : `10px`)};
`;

const StyledSkeleton = styled(Skeleton)`
  border-radius: 5;
`;

const StyledMidLine = styled.div`
  width: 100%;
  border-bottom: 1px solid #e1e1e7;
`;

export default OptionListSkeleton;
